import { Routes } from '@common/constants';

export const CATEGORY_IDS = [
  'rooms',
  'rates',
  'spa-stays',
  'spa-days',
  'spa-treatments',
  'spa-classes',
  'facilities',
  'tables',
  'products',
] as const;

export const CATEGORY_ROUTES: Record<string, string> = {
  rooms: Routes.ROOM_LIST,
  rates: Routes.RATE_LIST,
  'spa-stays': Routes.SPA_STAYS_LIST,
  'spa-days': Routes.SPA_DAY_LIST,
  'spa-treatments': Routes.SPA_TREATMENT_LIST,
  'spa-classes': Routes.SPA_CLASSES_LIST,
  facilities: Routes.FACILITY_LIST,
  tables: Routes.TABLES_HOME,
  products: Routes.PRODUCT_LIST,
};
